<template>
  <div class="mt-3">
    <template v-if="erpCamposIntegracao">
      <px-campos-integracao type="compra-item"
                            dense
                            :readonly="isCadastrosAdicionaisReadonly"
                            :form-data="produto.cadastrosAdicionais"
                            @replicar-campo="onReplicarCampo"/>
    </template>
    <v-row dense class="mt-3">
      <v-col cols="12" sm="6">
        <px-select-enum
          dense
          label="Finalidade da compra"
          :items="finalidades"
          class="rounded-tag-small"
          v-model="produto.finalidadeCompra"/>
      </v-col>
      <v-col cols="12" sm="3">
        <px-date-picker dense
                        label="Prazo de entrega solicitado"
                        input-class="required rounded-tag-small"
                        :error="$v.produto.dataPrevisaoEntrega.$error"
                        @blur="$v.produto.dataPrevisaoEntrega.$touch()"
                        v-model="produto.dataPrevisaoEntrega"/>
      </v-col>
      <v-col cols="12" sm="3">
        <px-date-picker dense
                        label="Data de faturamento"
                        input-class="required rounded-tag-small"
                        :error="$v.produto.dataFaturamento.$error"
                        @blur="$v.produto.dataFaturamento.$touch()"
                        v-model="produto.dataFaturamento"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" :md="showCentroCusto ? '6' : '12'">
        <px-autocomplete-projeto
          dense
          :class="`rounded-tag-small ${isProjetoRequired ? 'required' : ''}`"
          :disabled="isProjetoReadonly"
          :error="$v.produto.projeto.$error"
          @blur="$v.produto.projeto.$touch()"
          v-model="produto.projeto"/>
      </v-col>
      <v-col cols="12" md="6" v-if="showCentroCusto">
        <px-autocomplete-centro-custo
          dense
          :class="`rounded-tag-small ${isCentroCustoRequired ? 'required' : ''}`"
          :disabled="isCentroCustoReadonly"
          :error="$v.produto.centroCusto.$error"
          @blur="$v.produto.centroCusto.$touch()"
          v-model="produto.centroCusto"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="6">
        <v-textarea
          outlined
          auto-grow
          label="Especificação"
          counter="1500"
          rows="3"
          class="rounded-tag-small"
          v-model="produto.especificacaoProduto"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-textarea
          outlined
          auto-grow
          label="Observações externas"
          counter="1500"
          rows="3"
          class="rounded-tag-small"
          v-model="produto.observacaoExterna"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6"
             v-if="produto.arquivosComprador && produto.arquivosComprador.length">
        <span class="caption font-weight-bold">Arquivos cotados</span>
        <px-anexo-chip :files="produto.arquivosComprador"
                       download-base-path="files/download-comprador"/>
      </v-col>
      <v-col cols="12" sm="6"
             v-if="produto.arquivosFornecedor && produto.arquivosFornecedor.length">
        <span class="caption font-weight-bold">Arquivos do fornecedor</span>
        <px-anexo-chip :files="produto.arquivosFornecedor"
                       download-base-path="files/download-fornecedor"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <px-input-currency
            dense
            disabled
            label="Valor total DIFAL"
            class="rounded-tag-small"
            v-model="valorDifalConvertido"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';
import {
  isFieldRequiredEntityItens,
  isFieldReadonlyEntityItens,
  isFieldHiddenEntityItens,
} from '@/modules/erp-campos/erp-campos-utils';
import validationMixin from '@/mixins/validation-mixin';
import { FinalidadeCompra } from 'px-business-components';
import { isDateAfterOrSameToday } from '@/utils/date-utils';

export default {
  mixins: [validationMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    erpCamposIntegracao: {
      type: String,
    },
    camposObrigatorios: Object,
    camposReadonly: Object,
    camposHidden: Object,
    hasAnyItemFromRequisicao: Boolean,
  },
  data() {
    return {
      finalidades: FinalidadeCompra.values,
    };
  },
  computed: {
    isCentroCustoRequired() {
      return isFieldRequiredEntityItens('centroCusto', this.camposObrigatorios);
    },
    isProjetoRequired() {
      return isFieldRequiredEntityItens('projeto', this.camposObrigatorios);
    },
    valorDifalConvertido() {
      return this.produto.impostos.valorDifalConvertido * this.produto.quantidade;
    },
    isCentroCustoReadonly() {
      return isFieldReadonlyEntityItens('centroCusto', this.camposReadonly) && this.hasAnyItemFromRequisicao;
    },
    isProjetoReadonly() {
      return isFieldReadonlyEntityItens('projeto', this.camposReadonly) && this.hasAnyItemFromRequisicao;
    },
    isCadastrosAdicionaisReadonly() {
      return isFieldReadonlyEntityItens('cadastrosAdicionais', this.camposReadonly) && this.hasAnyItemFromRequisicao;
    },
    showCentroCusto() {
      return !isFieldHiddenEntityItens('centroCusto', this.camposHidden);
    },
  },
  methods: {
    validate() {
      const isInvalid = this.validateForm();
      if (isInvalid) {
        this.$emit('invalid');
      }
      return isInvalid;
    },
    onReplicarCampo(campo) {
      this.$emit('replicar-campo', campo);
    },
  },
  validations: {
    produto: {
      centroCusto: {
        required: requiredIf(function () {
          return this.isCentroCustoRequired;
        }),
      },
      projeto: {
        required: requiredIf(function () {
          return this.isProjetoRequired;
        }),
      },
      dataFaturamento: {
        isDateAfterOrSameToday,
      },
      dataPrevisaoEntrega: {
        isDateAfterOrSameToday,
      },
    },
  },
};
</script>
